import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import accounting from './accounting';
import auxiliar_accountings from './auxiliar_accountings';
import book from './book';
import bookings, { bookings_has_more_Reducer as bookings_has_more } from './bookings';
import comments from './comments';
import floors from './floors';
import user from './user';
import properties from './properties';
import property from './property';
import periods from './periods';
import period from './period';
import rates from './rates';
import rooms from './rooms';
import room from './room';
import offers from './offers';
import offer from './offer';
import occupancy_summary from './occupancy_summary';
import occupancy_graph from './occupancy_graph';
import payment_methods from './payment_methods';
import plans from './plans';
import plan from './plan';
import countries from './countries';
import country_codes from './country_codes';
import staffs from './staffs';
import staff from './staff';
import guests from './guests';
import guest from './guest';
import coorps from './coorps';
import coorp from './coorp';
import nationalities from './nationalities';
import log_entries from './log_entries';
import report_entries from './report_entries';


import auth from './auth';
import arriving_today from './arriving_today';
import hk_items from './hk_items';
import hk_movements from './hk_movements';
import charge_types from './charge_types';
import rate_types from './rate_types';
import charges_report from './charges_report';
import transfer_targets from './transfer_targets';

const rootReducer = combineReducers({
    routing: routerReducer,
    auth,
    book,
    bookings,
    bookings_has_more,
    user,
    properties, 
    property,
    periods,
    period,
    countries,
    country_codes,
    offers,
    offer,
    plans,
    plan,
    rooms,
    room,
    rates,
    staffs,
    staff,
    floors,
    comments,
    accounting,
    auxiliar_accountings,
    payment_methods,
    occupancy_summary,
    occupancy_graph,
    guests,
    guest,
    coorps,
    coorp,
    nationalities,
    log_entries,
    report_entries,
    arriving_today,
    hk_items,
    hk_movements,
    charge_types,
    rate_types,
    charges_report,
    transfer_targets,
});

export default rootReducer;
